import * as React from 'react';
import styled from 'styled-components';
import { useQuery } from 'urql';

import Loader from '../../shared/components/Loader';
import Error from '../components/Error';
import Inspiration from './Inspiration';
import { IArgs, IData, query } from './query';

interface IProps {
    id: string;
}

const Wrapper = styled.main`
    padding: 0 15px;
    flex-grow: 1;
    max-width: 1030px;
    width: 100%;
`;

function Inspirations({ id }: IProps): JSX.Element {
    const [result] = useQuery<IData, IArgs>({
        query,
        requestPolicy: 'network-only',
        variables: { id },
    });
    if (result.fetching) {
        return <Wrapper style={{ height: 200 }}>
            <Loader />
        </Wrapper>;
    } else if (result.error) {
        return <Wrapper>
            <Error />
        </Wrapper>;
    }
    return <Wrapper>
        {result.data.learningPath.inspirations.map(insp => <Inspiration inspiration={insp} key={insp.id} />)}
    </Wrapper>;
}

export default Inspirations;
